import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { SITE_NAME } from "@/lib/seoMap";

export default function InsightPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => {
    api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <main className="pt-40 pb-24 text-center" data-testid="insight-not-found">
      <h1 className="font-serif text-5xl">Article not found</h1>
      <Link to="/insights" className="mt-6 inline-flex items-center gap-2 link-underline">Back to insights</Link>
    </main>
  );
  if (!post) return <main className="pt-40 pb-24" />;

  return (
    <main className="pt-32 pb-24" data-testid="insight-post">
      <SEO
        title={`${post.title} — ${SITE_NAME} Insights`}
        description={post.excerpt}
        path={`/insights/${post.slug}`}
      />
      <article className="max-w-[780px] mx-auto px-6 lg:px-10">
        <Link to="/insights" className="inline-flex items-center gap-2 text-[13px] text-[color:var(--text-muted)] hover:text-[color:var(--text)] mb-8">
          <ArrowLeft size={14} /> All articles
        </Link>
        <div className="overline mb-4">{post.category}</div>
        <h1 className="font-serif text-5xl md:text-6xl tracking-[-0.02em] leading-[1]">{post.title}</h1>
        <p className="mt-6 text-[16px] text-[color:var(--text-muted)] leading-relaxed">{post.excerpt}</p>
        {post.cover_image && (
          <img src={post.cover_image} alt={post.title} className="mt-10 w-full rounded-2xl aspect-[16/9] object-cover" />
        )}
        <div className="mt-10 text-[15.5px] leading-[1.75] text-[color:var(--text)] whitespace-pre-wrap">{post.content}</div>
      </article>
    </main>
  );
}
